import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorB6ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorB6ByHealthTeamData {
	esbHealthTeamId: number = 0;
	esbHealthTeamIne: string = "";
	esbHealthTeamName: string = "";
	linkedHealthTeamId: number = 0;
	linkedHealthTeamIne: string = "";
	linkedHealthTeamName: string = "";
	totalProcedures: number = 0;
	totalProceduresLinked: number = 0;
	totalAtraumaticRestorativeTreatmentProcedures: number = 0;
	totalAtraumaticRestorativeTreatmentProceduresLinked: number = 0;
}

export async function getResumeIndicatorB6ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorB6ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorB6ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b6/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorB6ByHealthTeamData>();
}
